import { api } from '@/store/helpers'
import { SET_ENGAGE, SET_LOADING, SET_ERROR } from '@/store/mutation-types'

/**
 * Retry a promise with a fixed delay between attempts.
 *
 * @param {Function} fn - The function to retry
 * @param {Number} retries - Number of retries remaining
 * @param {Number} delay - Delay in milliseconds between retries
 * @return {Promise}
 */
const retryWithDelay = async (fn, retries = 3, delay = 5000) => {
	try {
		return await fn()
	} catch (error) {
		if (retries > 0) {
			await new Promise(resolve => setTimeout(resolve, delay))
			return retryWithDelay(fn, retries - 1, delay)
		}
		throw error
	}
}

export default {
	async getEngage({ commit, rootGetters }) {
		const partner = rootGetters['partners/active']

		if (!partner || !partner.id) {
			console.error('No active partner found')
			return
		}

		commit(SET_LOADING, true)
		commit(SET_ERROR, false)
		try {
			const response = await retryWithDelay(
				() =>
					api()
						.partners()
						.engage(partner.id),
				3,
				5000
			)
			const data = response?.response
			commit(SET_ENGAGE, {
				url: data?.dashboardToken,
				expiry: data?.expiration_hours,
			})
		} catch (error) {
			console.error('Failed to fetch engage data after retries:', error)
			commit(SET_ERROR, true)
		} finally {
			commit(SET_LOADING, false)
		}
	},
}
